/* eslint-disable no-nested-ternary */
import {
    Button, Input, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'appkit-react';

const RenameFile = ({
    visible, setVisible, fileName, fileNameError, fileNameIsValid, inputHandler, onBlurHandler, onSave, type, renameFolderOrFileIsLoading,
}) => {
    const getFileNameErrorMsg = () => {
        let msg = '';
        if (fileNameError) {
            msg = 'File name is required.';
        } else if (fileNameIsValid) {
            msg = `Invalid file name. A file name can't contain - ${'\\ / : * ? < > | "'}`;
        }
        return msg;
    };

    return (
        <div>
            <Modal
                className="add-and-edit-modal"
                visible={visible}
                onCancel={() => { setVisible(false); }}
                style={{ marginTop: '10rem' }}
                backdropClosable={false}
            >
                <ModalHeader>
                    <div className="a-modal-header">
                        <div className="modal-title-left">
                            <div className="modal-title">
                                Rename
                                {type === 'file' ? ' file' : ' folder'}
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div className="create-folder-modal-container">
                        <div className="create-folder-form-input-right-col">
                            <Input
                                placeholder="Enter file name"
                                type="text"
                                name="fileName"
                                value={fileName}
                                hasError={fileNameError || fileNameIsValid}
                                errMsg={getFileNameErrorMsg()}
                                onChange={e => inputHandler(e)}
                                onBlur={onBlurHandler}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter style={{ justifyContent: 'flex-end' }}>
                    <Button kind="secondary" onClick={() => { setVisible(false); }} size="lg"> Cancel </Button>
                    <Button kind="primary" size="lg" onClick={onSave} isLoading={renameFolderOrFileIsLoading}> Rename </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default RenameFile;
